var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{style:(_vm.color)},[_c('router-view',{key:_vm.routeKey,on:{"reset-route":_vm.resetRoute}}),_c('svg-icons'),_c('portal-target',{attrs:{"name":"body"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }